module.exports = __webpack_public_path__ + "img/bt3.2ff160fd.png";